module.exports = __webpack_public_path__ + "static/brian-kulp-55f580c3761267ab420013911787a4da.png";